import StatusColors from 'const/statusColors';
import { DossierStatus } from 'types/Dossier';
import { StatusColor } from 'types/Status';

export const getDossierStatusColor = (status?: DossierStatus): StatusColor => {
  // Référence couleurs: https://docs.google.com/spreadsheets/d/11_BRm3rdT6hP_KuUXPs7yLJDyG4Xz65vg1oH1sSk6ig/edit?gid=0#gid=0
  switch (status) {
    case DossierStatus.EtudeEnCours:
    case DossierStatus.EnCoursDeValidation:
      return StatusColors.BleuHellio;

    case DossierStatus.OffreEmise:
    case DossierStatus.ChantierEnCours:
    case DossierStatus.OffreAcceptee:
      return StatusColors.Orange;

    case DossierStatus.DocumentsEnAttente:
      return StatusColors.Rose;

    case DossierStatus.EnAttenteDeControle:
      return StatusColors.Marron;

    case DossierStatus.Incomplet:
      return StatusColors.Rouge;

    case DossierStatus.Valide:
    case DossierStatus.Termine:
    case DossierStatus.PrimeVersee:
      return StatusColors.Vert;

    case DossierStatus.Refuse:
    case DossierStatus.Abandon:
    default:
      return StatusColors.Gris;
  }
};
